const BRASS_ACTION_TYPES = {
  LOAD_BRASS: 'brass/LOAD_BRASS',
};

export default BRASS_ACTION_TYPES;
